import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import Nav from './Nav';

import { navWrapperSx } from '../../homeSsrStyles';

function NavContainer(props) {
  const [inverse, setInverse] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = (window.scrollY || window.pageYOffset) > 80;
      setInverse(prev => (prev === scrolled ? prev : scrolled));
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Box sx={navWrapperSx}>
      <Nav {...props} inverse={inverse} />
    </Box>
  );
}

export default NavContainer;
